import account from "./account.svg";
import djinn from "./djinn.svg";
import dwarf from "./dwarf.svg";
import elf from "./elf.svg";
import ent from "./ent.svg";
import general from "./general.svg";
import giant from "./giant.svg";
import hobbit from "./hobbit.svg";
import human from "./human.svg";
import necromancer from "./necromancer.svg";
import orc from "./orc.svg";
import vampire from "./vampire.svg";

export const loaders: {[keys: string]: any} = {
  account,
  djinn,
  dwarf,
  elf,
  ent,
  general,
  giant,
  hobbit,
  human,
  necromancer,
  orc,
  vampire
}
